import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
  .set('GetListReportes', new Immutable.List([]))
  .set('GetListSolicitudes', new Immutable.List([]))


/*Types*/
export const ACTION_GET_REPORTES_LIST = "ACTION_GET_REPORTES_LIST"
export const ACTION_GET_SOLICITUDES_LIST = "ACTION_GET_SOLICITUDES_LIST"



/*Reducer*/
export default (state = initialState, action) => {

  switch (action.type) {
    case ACTION_GET_REPORTES_LIST:
      return state.set('GetListReportes', new Immutable.List(action.Obj))
    case ACTION_GET_SOLICITUDES_LIST:
      return state.set('GetListSolicitudes', new Immutable.List(action.Obj))
    default:
      return state
  }

}

/*Action Creators*/

export const getReportes = (form) => {


  return (dispatch) => {
    dispatch(isLoading(true))
    return new ClientHttpRequest({
      service: 'api/listReports',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({
        type: ACTION_GET_REPORTES_LIST,
        Obj: new Immutable.List(Utils.createSelectReportes(response.data))
      })
     // dispatch({ type: ACTION_GET_REPORTES_LIST, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))

      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}



export const getSolicitudes = (form) => {

  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/listSolicitudes',
      method: 'POST',
      data: { ...form },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
      dispatch(isLoading(false))
      dispatch({ type: ACTION_GET_SOLICITUDES_LIST, Obj: response.data })
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}



export const postSolicitudes = (form) => {
  return (dispatch) => {
    dispatch(isLoading(true))

    return new ClientHttpRequest({
      service: 'api/SolicitudesReports',
      method: 'POST',
     // responseType:'arraybuffer',
      data: { ...form },
      headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
    }).request().then(response => {
     dispatch(isLoading(false))

    /*  const blob = new Blob([response.nombre], { type: 'application/pdf' })
      const fileName = `reporte-${Utils.getToday()}.pdf`
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      //a.href = objectUrl
      a.href = 'http://www.ite.educacion.es/formacion/materiales/107/cd/html/pdf/html11.pdf'

      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl)*/
      return response
    }).catch(error => {
      dispatch(isLoading(false))
      dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
      throw error
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/ReportsDis/ReportsDis.js